import { render, staticRenderFns } from "./passing-grade-limit-form.vue?vue&type=template&id=128ad214"
import script from "./passing-grade-limit-form.vue?vue&type=script&lang=js"
export * from "./passing-grade-limit-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports